(function(){"use strict";try{if(typeof document<"u"){var o=document.createElement("style");o.appendChild(document.createTextNode("._button_16uso_1._primary-button_16uso_1{color:var(--text-and-icon-inverse-default, #fff)!important;background:var(--bg-profilum-primary-default, #007aff);border:none;cursor:pointer;box-shadow:var(--shadow-button-primary, 0 5px 20px 0 rgba(147, 117, 251, .3))}._button_16uso_1._primary-button_16uso_1 ._loader-element_16uso_8{background:var(--text-and-icon-inverse-default, #fff)}._button_16uso_1._primary-button_16uso_1:hover:not(._disabled_16uso_11):not(:active):not(._loading_16uso_11){background:var(--bg-profilum-primary-hover, #0072ee)}._button_16uso_1._primary-button_16uso_1:active,._button_16uso_1._primary-button_16uso_1._active_16uso_14,._button_16uso_1._primary-button_16uso_1._loading_16uso_11{background:var(--bg-profilum-primary-active, #0066d5)}._button_16uso_1._primary-button_16uso_1 svg{fill:var(--text-and-icon-inverse-default, #fff)}")),document.head.appendChild(o)}}catch(t){console.error("vite-plugin-css-injected-by-js",t)}})();
const t = "_button_16uso_1", o = "_primary-button_16uso_1", e = "_loader-element_16uso_8", n = "_disabled_16uso_11", s = "_loading_16uso_11", _ = "_active_16uso_14", a = {
  button: t,
  primaryButton: o,
  loaderElement: e,
  disabled: n,
  loading: s,
  active: _
};
export {
  _ as active,
  t as button,
  a as default,
  n as disabled,
  e as loaderElement,
  s as loading,
  o as primaryButton
};
